import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import CopyEmailSocialButtons from '../../elements-buttons/CopyEmailSocialButtons';
import { tocByUseType } from '../data/utils';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

const MyListingsShareModal = ({ intl, listingData, ...props }) => {
  const useTypeData = tocByUseType[get(listingData, 'use_type')];
  const title = get(useTypeData, 'modalTitle', '');

  return (
    <BootstrapModal
      {...props}
      header={
        <h3>
          {title
            ? <FormattedMessage id="hosting.my_lisings_share_modal.share_usetype_listing_heading" defaultMessage="Share {useType} listing" values={{ useType: intl.formatMessage(title) }}/>
            : <FormattedMessage id="hosting.my_lisings_share_modal.share_listing_heading" defaultMessage="Share listing"/>}
        </h3>
      }
      body={
        <div className="social-modal">
          <CopyEmailSocialButtons
            listingData={listingData}
            origin="mylistings"
            campaign="listing_sharing"
            emailSubject={intl.formatMessage({ id: 'hosting.my_lisings_share_modal.email_subject', defaultMessage: 'Checkout out my venue on Peerspace' })}
          />
        </div>
      }
      modalSize="sm-size modal-sm"
    />
  );
};

MyListingsShareModal.propTypes = {
  listingData: PropTypes.object.isRequired,
  intl: intlShape
};

export default injectIntl(MyListingsShareModal);
